<div class="form-container service-form ms-large-t">
  <form *ngIf="reactiveForm && formStatus !== FormStatus.COMPLETE" [formGroup]="reactiveForm" (ngSubmit)="onSubmit()">
    <fcom-notification
      *ngIf="formStatus === FormStatus.ERROR"
      class="mr-medium-b"
      [layout]="NotificationLayout.BLOCK"
      [theme]="NotificationTheme.ALERT"
    >
      {{ 'SERVICE_FORMS.serviceForms.error.title' | finLocalization }}
    </fcom-notification>

    <h3 class="ms-small-b">
      {{ 'SERVICE_FORMS.serviceForms.corporateContactForm.messageToFinnair' | finLocalization }}
    </h3>
    <span class="block pr-medium-b font-body-1 nordic-blue-900-text">
      {{ 'SERVICE_FORMS.serviceForms.corporateContactForm.mandatoryFields' | finLocalization }}
    </span>
    <fcom-radio-item-group
      [options]="topics"
      [parentForm]="reactiveForm"
      [controlName]="'topic'"
      [translationPrefix]="'SERVICE_FORMS.serviceForms.corporateContactForm.topic'"
    >
    </fcom-radio-item-group>
    <div class="ms-large-t">
      <fcom-text-input
        #message
        class="block ms-small-t"
        [parentForm]="reactiveForm"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.corporateContactForm.message'"
        [controlName]="'message'"
        [placeHolder]="'SERVICE_FORMS.serviceForms.corporateContactForm.message.placeholder'"
        [type]="TextInputType.TEXTAREA"
        [characterLimit]="1000"
        [characterCount]="message.control?.value?.length || 0"
        [rows]="10"
      ></fcom-text-input>
    </div>

    <fcom-notification class="mr-medium-b">
      {{ 'SERVICE_FORMS.serviceForms.corporateContactForm.languageNotification' | finLocalization }}
    </fcom-notification>

    <fcom-file-uploader
      class="mr-large-b"
      *ngIf="profile$ | async"
      [allowedFileTypes]="allowedFileTypes"
      [controlName]="'attachments'"
      [i18n]="'SERVICE_FORMS.serviceForms.fields.fileUploader' | finLocalization"
      [maxAttachments]="maxAttachments"
      [maxSizeInBytes]="THREE_MEGABYTES"
      [parentForm]="reactiveForm"
      [uploadService]="uploadFile()"
      #fileUploader
    ></fcom-file-uploader>

    <h3 class="ms-small-b" #contactDetailsTitle>
      {{ 'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.title' | finLocalization }}
    </h3>

    <ng-container *ngIf="(profile$ | async) === undefined; else loggedInUser">
      <span class="block pr-medium-b font-body-1 nordic-blue-900-text" data-testid="contact-details-form">
        {{ 'SERVICE_FORMS.serviceForms.corporateContactForm.mandatoryFields' | finLocalization }}
      </span>

      <fcom-text-input
        [parentForm]="reactiveForm"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.companyName'"
        [controlName]="'companyName'"
        [placeHolder]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.companyName.placeholder'"
      ></fcom-text-input>

      <ng-container *ngIf="countryCodes$ | async as countryCodes">
        <fin-select-input
          [parentForm]="reactiveForm"
          [controlName]="'country'"
          [options]="countries$ | async"
          [selectLabelTranslationKey]="
            'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.country.placeholder'
          "
          [translationPrefix]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.country'"
          (change)="countryChanged(reactiveForm.get('country').value, countryCodes)"
        ></fin-select-input>
      </ng-container>

      <div class="flex flex--space-between columns-3">
        <div>
          <fin-select-input
            [parentForm]="reactiveForm"
            [controlName]="'salutation'"
            [options]="salutations$ | async"
            [selectLabelTranslationKey]="
              'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.salutation.unselected'
            "
            [translationPrefix]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.salutation'"
          ></fin-select-input>
        </div>
        <div>
          <fcom-text-input
            [parentForm]="reactiveForm"
            [translationPrefix]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.firstName'"
            [controlName]="'firstName'"
            [placeHolder]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.firstName.placeholder'"
          ></fcom-text-input>
        </div>
        <div>
          <fcom-text-input
            [parentForm]="reactiveForm"
            [translationPrefix]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.familyName'"
            [controlName]="'familyName'"
            [placeHolder]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.familyName.placeholder'"
          ></fcom-text-input>
        </div>
      </div>

      <fcom-text-input
        [parentForm]="reactiveForm"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.email'"
        [controlName]="'email'"
        [placeHolder]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.email.placeholder'"
      ></fcom-text-input>

      <div class="flex flex--space-between columns-2">
        <div>
          <fin-select-input
            [parentForm]="reactiveForm"
            [controlName]="'phonePrefix'"
            [options]="phonePrefixes$ | async"
            [selectLabelTranslationKey]="
              'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.phonePrefix.unselected'
            "
            [translationPrefix]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.phonePrefix'"
          ></fin-select-input>
        </div>
        <div>
          <fcom-text-input
            [parentForm]="reactiveForm"
            [translationPrefix]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.phoneNumber'"
            [controlName]="'phoneNumber'"
            [placeHolder]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.phoneNumber.placeholder'"
          ></fcom-text-input>
        </div>
      </div>
      <fcom-text-input
        [parentForm]="reactiveForm"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.customerNumber'"
        [controlName]="'customerNumber'"
        [placeHolder]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.customerNumber.placeholder'"
      ></fcom-text-input>
    </ng-container>
    <ng-template #loggedInUser>
      <ng-container *ngIf="profile$ | async as profile">
        <div class="ms-small-b" data-testid="contact-details-panel">
          <span class="font-body-1 ms-xxsmall-b nordic-blue-400-text block">
            {{ 'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.companyName.label' | finLocalization }}
          </span>
          <span class="font-body-1 bold-type block">{{ profile.corporate?.name }}</span>
        </div>

        <div class="ms-small-b">
          <span class="font-body-1 ms-xxsmall-b nordic-blue-400-text block">
            {{ 'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.country.label' | finLocalization }}
          </span>
          <span class="font-body-1 bold-type block">{{ selectedCountryCode?.name }}</span>
        </div>

        <div class="ms-small-b">
          <span class="font-body-1 ms-xxsmall-b nordic-blue-400-text block">
            {{ 'SERVICE_FORMS.CSServiceForms.fields.name.label' | finLocalization }}
          </span>
          <span class="font-body-1 bold-type block">{{ profile.firstname }} {{ profile.lastname }}</span>
        </div>

        <div class="ms-small-b">
          <span class="font-body-1 ms-xxsmall-b nordic-blue-400-text block">
            {{ 'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.email.label' | finLocalization }}
          </span>
          <span class="font-body-1 bold-type block">{{ profile.email }}</span>
        </div>

        <div class="ms-small-b">
          <span class="font-body-1 ms-xxsmall-b nordic-blue-400-text block">
            {{ 'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.phoneNumber.label' | finLocalization }}
          </span>
          <span class="font-body-1 bold-type block">
            {{ profile.mobilePhone }}
          </span>
        </div>

        <div class="ms-small-b">
          <span class="font-body-1 ms-xxsmall-b nordic-blue-400-text block">
            {{
              'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.customerNumber.loggedInLabel'
                | finLocalization
            }}
          </span>
          <span class="font-body-1 bold-type block">{{ profile.corporate?.clientId }}</span>
        </div>
      </ng-container>
    </ng-template>

    <div class="flex flex--end ms-xlarge-t ps-large-t ms-small-b border-top nordic-blue-100-border">
      <fcom-button
        data-testid="submit"
        [type]="ButtonType.SUBMIT"
        [disabled]="fileUploader?.isUploading ?? false"
        [loading]="formStatus === FormStatus.LOADING"
        [text]="'SERVICE_FORMS.serviceForms.corporateContactForm.submit' | finLocalization"
        [theme]="ButtonTheme.LIGHT_PRIMARY_CTA_HEATHER"
      >
      </fcom-button>
    </div>

    <fcom-notification *ngIf="formStatus === FormStatus.ERROR" [theme]="NotificationTheme.ALERT" class="ms-small-b">
      {{ 'errors.generic.title' | finLocalization }}
    </fcom-notification>

    <fcom-notification *ngIf="formStatus !== FormStatus.PRECONDITION_REQUIRED">
      {{ 'SERVICE_FORMS.serviceForms.corporateContactForm.handleRequestNotification' | finLocalization }}
    </fcom-notification>

    <fcom-notification *ngIf="formStatus === FormStatus.PRECONDITION_REQUIRED">
      {{ 'SERVICE_FORMS.serviceForms.preconditionRequired' | finLocalization }}
    </fcom-notification>
  </form>

  <div *ngIf="formStatus === FormStatus.COMPLETE">
    <h3 class="ms-small-b" #thankYouTitle>
      {{ 'SERVICE_FORMS.serviceForms.corporateContactForm.thankYou.title' | finLocalization }}
    </h3>
    <span class="font-body-1">
      {{ 'SERVICE_FORMS.serviceForms.corporateContactForm.thankYou.message' | finLocalization }}
    </span>
    <span class="font-body-1 block mr-small-y">
      {{ 'SERVICE_FORMS.serviceForms.corporateContactForm.thankYou.regards' | finLocalization }}
    </span>
    <span class="font-body-1">
      {{ 'SERVICE_FORMS.serviceForms.corporateContactForm.thankYou.signature' | finLocalization }}
    </span>
    <div class="flex flex--end">
      <a class="btn bold-type no-underline" [finLink]="returnLink$ | async">
        {{ 'SERVICE_FORMS.serviceForms.corporateContactForm.thankYou.button' | finLocalization }}
      </a>
    </div>
  </div>
</div>
